import * as React from "react";
import { Collapse, Slider, Input } from "antd";
import styled from "styled-components";
import update from "immutability-helper";
import { ThemeContext } from "../../../../themeDesigner";

const Panel = Collapse.Panel;

const Label = styled.label`
  font-family: Muli;
  font-size: 13px;
  font-weight: 600;
  color: #7f90af;
  display: block;
  margin-bottom: 8px;
`;

const SettingRow = styled.div`
  margin-bottom: 16px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
  }
`;

export default function BorderRadiusProperties() {
  const { themeProps, setThemeProps } = React.useContext(ThemeContext);
  const borderRadius = themeProps.widget.modernUIStyles.borderRadius;

  const handleUpdate = (key: string, value: any) => {
    const numValue = typeof value === "number" ? value : (Array.isArray(value) ? value[0] : value);
    const updated = update(themeProps, {
      widget: {
        modernUIStyles: {
          borderRadius: {
            [key]: { $set: numValue },
          },
        },
      },
    });
    setThemeProps(updated);
  };

  return (
    <Collapse defaultActiveKey={["1"]}>
      <Panel header="Border Radius Settings" key="1">
        <SettingRow>
          <Label>Input Box Border Radius (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={borderRadius.inputBorderRadius}
              onChange={(e) =>
                handleUpdate("inputBorderRadius", parseInt(e.target.value) || 24)
              }
              min={0}
              max={50}
            />
            <span>{borderRadius.inputBorderRadius}px</span>
          </Wrapper>
          <Slider
            value={borderRadius.inputBorderRadius}
            onChange={(val) => handleUpdate("inputBorderRadius", val)}
            min={0}
            max={50}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Message Bubble Border Radius (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={borderRadius.messageBubbleBorderRadius}
              onChange={(e) =>
                handleUpdate("messageBubbleBorderRadius", parseInt(e.target.value) || 12)
              }
              min={0}
              max={50}
            />
            <span>{borderRadius.messageBubbleBorderRadius}px</span>
          </Wrapper>
          <Slider
            value={borderRadius.messageBubbleBorderRadius}
            onChange={(val) => handleUpdate("messageBubbleBorderRadius", val)}
            min={0}
            max={50}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Suggestion Pill Border Radius (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={borderRadius.suggestionBorderRadius}
              onChange={(e) =>
                handleUpdate("suggestionBorderRadius", parseInt(e.target.value) || 20)
              }
              min={0}
              max={50}
            />
            <span>{borderRadius.suggestionBorderRadius}px</span>
          </Wrapper>
          <Slider
            value={borderRadius.suggestionBorderRadius}
            onChange={(val) => handleUpdate("suggestionBorderRadius", val)}
            min={0}
            max={50}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Header Border Radius (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={borderRadius.headerBorderRadius}
              onChange={(e) =>
                handleUpdate("headerBorderRadius", parseInt(e.target.value) || 12)
              }
              min={0}
              max={50}
            />
            <span>{borderRadius.headerBorderRadius}px</span>
          </Wrapper>
          <Slider
            value={borderRadius.headerBorderRadius}
            onChange={(val) => handleUpdate("headerBorderRadius", val)}
            min={0}
            max={50}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>
      </Panel>
    </Collapse>
  );
}
